import type { CurrencyCode } from '@klear/constants/currency'
import { Money } from '@klear/money'
import type { RouterOutputs } from '@klear/ui/lib/trpc'

export type SpvUtilizationWire = RouterOutputs['klearAccount']['getUtilization']

type SpvUtilizationRowWire = SpvUtilizationWire['byCurrency'][number]

export type SpvUtilizationByCurrency = SpvUtilizationRowWire

export type SpvUtilizationData = SpvUtilizationWire

function moneyFromUtilizationField(value: SpvUtilizationRowWire['totalInbound']): Money {
  return value ?? Money.zero()
}

export function spvUtilizationFromWire(raw: SpvUtilizationWire): SpvUtilizationData {
  return {
    treasuryCurrency: raw.treasuryCurrency,
    byCurrency: raw.byCurrency.map(
      (row: SpvUtilizationRowWire): SpvUtilizationByCurrency => ({
        currency: row.currency,
        totalInbound: moneyFromUtilizationField(row.totalInbound),
        inTransitInbound: moneyFromUtilizationField(row.inTransitInbound),
        expectedRecoveriesTotal: moneyFromUtilizationField(row.expectedRecoveriesTotal),
        invoiceOutbound: moneyFromUtilizationField(row.invoiceOutbound),
        paasOutbound: moneyFromUtilizationField(row.paasOutbound),
        totalOutbound: moneyFromUtilizationField(row.totalOutbound),
        totalAmount: moneyFromUtilizationField(row.totalAmount),
        utilization: row.utilization,
        committed: moneyFromUtilizationField(row.committed),
        headroom: moneyFromUtilizationField(row.headroom),
        draftPipeline: moneyFromUtilizationField(row.draftPipeline)
      })
    )
  }
}

export function utilizationForCurrency(
  data: SpvUtilizationData | null | undefined,
  currency: CurrencyCode
): SpvUtilizationByCurrency | null {
  return data?.byCurrency.find((row) => row.currency === currency) ?? null
}
